
interface ResourceManagerInterface {
    getMessage(key: string): string;
}

export class Enum {
    static getFormattedValue(
        value: number | string,
        enumToUse: any,
        enumName: string,
        messageResourceManager: ResourceManagerInterface
    ): string {
        if (value === null || value === undefined) return '';
        if (typeof value === 'number' && isNaN(value)) return '';
        if (typeof value === 'string' && value.trim() === '') return '';

        const enumValue = enumToUse[value];
        return enumValue !== undefined ?
            (messageResourceManager?.getMessage(`${enumName}_${enumValue}`) || enumValue.toString()) :
            '';
    }
}